import React from 'react';
import './footer.component.scss';
import FooterModel from '../../models/footer.model';
import { Icon } from '@mui/material';
import IconesSVGComponent from '../svg-icon/svg-icon.component';
import { CONSTANTS } from '../../constants/constants';
import { NavLink } from 'react-router-dom';
import MenuModel from '../../models/menu.model';

export type FooterComponentProps = {
  footer?: FooterModel;
  menu?: MenuModel;
}

function FooterComponent(props: FooterComponentProps) {
  var fullYear = new Date().getFullYear();

  const css = `
    footer {
      background: ${props.footer?.cor_de_fundo ? props.footer?.cor_de_fundo : '#fff'};
      color: ${props.footer?.cor_do_texto ? props.footer?.cor_do_texto : '#000'};
    }

    footer h3 {
      color: ${props.footer?.cor_dos_titulos ? props.footer?.cor_dos_titulos : '#000'};
    }

    footer ul li a, footer ul li a:hover {
      color: ${props.footer?.cor_dos_menus ? props.footer?.cor_dos_menus : '#000'};
    }

    footer .bot-bar {
      background: ${props.footer?.cor_de_fundo_barra_inferior ? props.footer?.cor_de_fundo_barra_inferior : '#ccc'};
      color: ${props.footer?.cor_do_texto_barra_inferior ? props.footer?.cor_do_texto_barra_inferior : '#000'};
    }

    footer .bot-bar ul li a, footer .bot-bar ul li a:hover {
      color: ${props.footer?.cor_redes_sociais ? props.footer?.cor_redes_sociais : '#000'};
    }
  `;

  return (
    <footer>
      <style>{css}</style>
      <div className="container">
        <div className="flex flex-sp flex-wr">
          <div className="box-logo">
            <img src={props.footer?.logo.src} alt="Logo" />
            <p>{props.footer?.breve_texto}</p>
            <ol>
              {props.footer?.itens_com_icones?.map((item, iIcones) => (
                <li key={iIcones}>
                  <IconesSVGComponent iconName={item.icone}></IconesSVGComponent>
                  <span>{item.legenda}</span>
                </li>
              ))}
            </ol>
          </div>
          {props.footer?.menus?.map((item, iItens) => (
            <div className='item-footer' key={iItens}>
              <h3>{item.titulo_do_menu}</h3>
              <ul>
                {item.item_menu?.map((item2, iItens2) => (
                  <li key={iItens2}>
                    {
                      item2.tipo === CONSTANTS.TIPO_BOTAO.LINK_INTERNO ?
                        <NavLink to={item2.url}>
                          {item2.texto}
                        </NavLink>
                        :
                        <a target='_blank' href={item2.url}>
                          {item2.texto}
                        </a>
                    }
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="bot-bar">
        <div className="container">
          <div className="flex flex-sp flex-cv flex-wr">
            <div className="esq">
              {props.menu?.nome_do_site} ©{fullYear}
            </div>
            <div className="dir">
              <ul>
                {props.footer?.redes_sociais?.map((itemRedes, iItens) => (
                  <li key={iItens}>
                    <a target='_blank' href={itemRedes.url}>
                      <IconesSVGComponent iconName={itemRedes.icone}></IconesSVGComponent>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterComponent;
